import React from 'react';

class QualDrawSelect extends React.Component {
    constructor(props) {
        super(props);

        this.choicesInstance = null;
        this.selectRef = React.createRef();
    }

    componentDidMount() {
        const { options, defaultValue } = this.props;
        const block = 'randa-select';

        this.choicesInstance = new window.Choices(this.selectRef.current, {
            choices: options,
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: '',
            classNames: {
                containerOuter: `choices ${block}`,
                containerInner: `choices__inner ${block}__inner`,
                list: `choices__list ${block}__list`,
                listDropdown: `choices__list--dropdown ${block}__list--dropdown`,
                listSingle: `choices__list--single ${block}__list--single`,
                item: `choices__item ${block}__item`,
                itemSelectable: `choices__item--selectable ${block}__item--selectable`,
                itemDisabled: `choices__item--disabled ${block}__item--disabled`,
                itemChoice: `choices__item--choice ${block}__item--choice`
            }
        });

        if (defaultValue) {
            this.choicesInstance.setChoiceByValue(defaultValue);
        }
    }

    componentWillUnmount() {
        if (this.choicesInstance) {
            this.choicesInstance.destroy();
        }
    }

    getOptionValue = () => {
        const value = this.choicesInstance.getValue(true);

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    render() {
        return (
            <div className="qual-draw-select form-round-select">
                <select
                    className="form-round-select__native"
                    ref={this.selectRef}
                    onChange={this.getOptionValue}
                    disabled={this.props.isDisabled}
                >
                </select>
                <svg className="form-round-select__arrow-down" width="14" height="6" focusable="false">
                    <use xlinkHref="#icon-arrow-down-blue"></use>
                </svg>
            </div>
        );
    }
}

export default QualDrawSelect;
